import React, { Component } from "react";
import { Form, Button, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { get } from "lodash";
import MOMDesc from "../MOM/MOMDesc";
import {
  getColor,
  isValidArray,
  transformProjectCategoryId
} from "../../helper";
import { PATHS, ISSUE_STATUS } from "../../constant";
import { DisplayContent } from "../displayContent";
import {
  MultipleTags,
  OrganizationTemplate,
  ReadMore,
  RedirectUser
} from "../reusableComponent";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import DisplayByPermission from "../../component/DisplayByPermission";
import AgendaIssueDecision from "../agendaDetails/AgendaIssueDecision";
import { EscalationLevelModal } from "../reusableComponent/EscalationLevel/EscalationLevelModal";
import IssuePragatiReview from "../prgatiReview/IssuePragatiReview";
import { toolttipDisplayMessage } from "../issueList/helper";
import AgendaIssuePragatiReview from "../prgatiReview/AgendaIssuePragatiReview";
import { DisplayHtmlContent } from "../displayHtmlContent";
import PariveshData from "../pariveshData";
import AgendaIssuePragatiPipeline from "../prgatiReview/AgendaIssuePragatiPipeline";

export class IssueSingle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOtherPPList: false,
      displayPopUp: false,
      isPariveshModalVisible: false,
      selectedIssueSubCategoryId: null,
      selectedProposalNoParivesh: null
    };
  }

  selectionHandler = () => {
    const { idx, deleteHandler } = this.props;
    deleteHandler(idx);
  };

  toggleOtherPPList = () => {
    this.setState({
      showOtherPPList: !this.state.showOtherPPList
    });
  };

  // onToggleModal = () => {
  //   this.setState(prevState => ({
  //     displayPopUp: !prevState["displayPopUp"],
  //     viewMoreStatus: false
  //   }));
  // };

  showPraiveshModal = () => {
    //const { issueData } = this.state;
    const { issue } = this.props;
    console.log(issue);
    //let data = get(issueData, "data", null);
    const issueSubcategoryId = get(issue, "subCategoryId", null);
    const proposalNoParivesh = get(issue, "proposalNoParivesh", null);
    this.setState({
      isPariveshModalVisible: true,
      selectedIssueSubCategoryId: issueSubcategoryId,
      selectedProposalNoParivesh: proposalNoParivesh
    });
  };
  closePariveshModal = () => {
    this.setState({
      isPariveshModalVisible: false
    });
  };

  render() {
    const {
      IssueSelected,
      issue,
      fromAgendaDetailPage,
      meetingStatus,
      permission,
      agendaData,
      handleUpdateStatus,
      project
    } = this.props;
    const {
      showOtherPPList,
      displayPopUp,
      isPariveshModalVisible
    } = this.state;
    // let agendaIssue = null;
    // if (fromAgendaDetailPage) {
    //   agendaIssue = get(agendaData, "issuesData", []).find(
    //     item => item.id == issue.id
    //   );
    // }
    const isPragatiReview = get(issue, "issuePragatiReview");
    const isPragatiPipeline = get(issue, "issuePragatiPipeLine");

    let content;
    if (IssueSelected === "delete") {
      content = (
        <div
          className="delete-issue"
          title="Delete"
          onClick={this.selectionHandler}
        />
      );
    } else if (IssueSelected === "checkbox") {
      content = (
        <Form.Group controlId={`checkbox-${this.props.idx}`}>
          <Form.Check
            className={`form-checkbox ${issue.isSelected ? "checked" : ""}`}
          >
            <Form.Check.Input
              type="checkbox"
              name="select-issue"
              value={issue.isSelected}
            />
            <Form.Check.Label onClick={this.selectionHandler} />
          </Form.Check>
        </Form.Group>
      );
    } else {
      content = "";
    }
    // console.log("displayPopUp", displayPopUp);
    // console.log("hello", get(issue, "status"), get(agendaData, "meetingStatus"))
    // const showMeetingData = get(issue, "meetingDecisionDTOS", []).find(
    //   value => {
    //     return agendaData.id === value.meetingId;
    //   }
    // );
    // const { groupCategory } = getLocalstorage("user");
    // let pendingWithSMAndPMG = !(
    //   get(issue, "status") == ISSUE_STATUS["Pending with PMG"] ||
    //   get(issue, "status") == ISSUE_STATUS["Pending with SM"]
    // ) || get(showMeetingData, "decisionStatus") === "DRAFT";

    return (
      <React.Fragment>
        <div className="select-issue-wrapper agenda-issue-wrapper">
          {!fromAgendaDetailPage ? (
            <Form className="select-issue-form">{content}</Form>
          ) : (
            meetingStatus === "SCHEDULED" && (
              <DisplayByPermission
                display={
                  get(permission, "updateAllAgendaSuperPMG") &&
                  !get(permission, "canViewOnlyProject")
                }
              >
                <Form className="select-issue-form">{content}</Form>
              </DisplayByPermission>
            )
          )}

          <div className="issue-container">
            <div className="select-issue-content">
              <div className="issue-list-top">
                <div className="issue-list-header">
                  <div className="issue-status">
                    <span
                      className={`issue-number mt-1 ${
                        get(issue, "duplicate") ? "duplicate-issue-number" : ""
                      }`}
                    >
                      {get(issue, "duplicate") ? "Duplicate Issue" : "Issue"}{" "}
                      <b>
                        <Link
                          to={{
                            pathname: PATHS.ISSUE_DETAIL,
                            search: `?issueId=${get(
                              issue,
                              "id"
                            )}&&projectId=${get(issue, "project.id")}`
                          }}
                        >
                          #{get(issue, "project.displayId", "NA")}/
                          {get(issue, "id", "NA")}
                        </Link>
                      </b>
                    </span>
                    {/**CR 289 Changes Starts-Yajnadutta */}
                    <div className="mt-1" style={{ marginLeft: -10 }}>
                      {get(issue, "escalationLevelName", "NA") ==
                      null ? null : (
                        <EscalationLevelModal
                          IssueId={get(issue, "id")}
                          EscalationName={get(
                            issue,
                            "escalationLevelName",
                            "NA"
                          )}
                          pragatiDetailPage={true}
                          pragatiDetailPageCss={true}
                        />
                      )}
                    </div>
                    {/**CR 289 Changes End-Yajnadutta */}
                    <OverlayTrigger
                      defaultShow={false}
                      trigger="hover"
                      placement="top"
                      overlay={
                        <Tooltip className="issues-status-tooltip ">
                          {toolttipDisplayMessage(get(issue, "status", "NA"))}
                        </Tooltip>
                      }
                    >
                      <div className="issue-list-status mt-1">
                        <span
                          className={`issue-status-btn  ${getColor(
                            get(issue, "status", "NA").toLowerCase()
                          )} unClickable`}
                        >
                          {get(issue, "status", "NA")}
                        </span>
                      </div>
                    </OverlayTrigger>
                  </div>

                  {/* <h2 className="issue-title">{get(issue, "title", "NA")}</h2> */}
                  <h2
                    className="issue-title"
                    style={{
                      lineHeight: get(issue, "title", "NA").match(
                        /[\u0900-\u097F]/
                      )
                        ? "inherit"
                        : ""
                    }}
                  >
                    <Link
                      to={{
                        pathname: PATHS.ISSUE_DETAIL,
                        search: `?issueId=${get(issue, "id")}&&projectId=${get(
                          issue,
                          "project.id"
                        )}`
                      }}
                    >
                      <span
                        className={`${
                          get(issue, "title", "NA").match(/[\u0900-\u097F]/)
                            ? "hindi-text-wrap"
                            : ""
                        }`}
                      >
                        {get(issue, "title", "NA")}
                      </span>
                    </Link>
                  </h2>
                </div>
              </div>
              <div
                className={
                  meetingStatus === "DRAFT"
                    ? "issue-list-flag-wrapper"
                    : "issue-agenda-detail-flag-wrapper"
                }
              >
                <div className="issue-list-desc-comment-wrapper">
                  <div className="issue-list-middle issue-list-align">
                    <div className="issue-list-desc-wrapper">
                      <span className="issue-recipient">
                        <span className="issue-recipient-title">
                          Recipient{" "}
                          {transformProjectCategoryId(
                            get(issue, "recipientGroupCategory")
                          )}
                          : &nbsp;
                        </span>
                        {get(issue, "recipientGroup", "NA")}
                      </span>
                      {console.log("get(issue, recipientLabel)", issue)}
                      {get(issue, "districtName") ? (
                        <span className="issue-recipient">
                          <span className="issue-recipient-title">
                            {get(issue, "recipientLabel")}:
                          </span>{" "}
                          &nbsp;
                          {get(issue, "districtName", "NA")}
                        </span>
                      ) : null}
                      {get(issue, "secondaryState") ||
                      get(issue, "secondaryRecipientGroupName") ? (
                        <span className="issue-recipient">
                          <span className="issue-recipient-title">
                            Secondary Recipient:
                          </span>{" "}
                          {get(issue, "secondaryState", "NA") ||
                            get(issue, "secondaryRecipientGroupName", "NA")}
                        </span>
                      ) : get(issue, "secondaryMinistry") ? (
                        <span className="issue-recipient">
                          <span className="issue-recipient-title">
                            Secondary Recipient:
                          </span>{" "}
                          {get(issue, "secondaryMinistry", "NA")}
                        </span>
                      ) : null}
                      <p className="issue-category to-n-fro">
                        <span className="">
                          <span className="issue-category-title">
                            Issue Category: &nbsp;
                          </span>
                          {get(issue, "category", "NA")}
                        </span>
                        <span className="clowdy" />
                      </p>
                      {get(issue, "subCategory") ? (
                        <p className="issue-sub-category to-n-fro">
                          <span className="">
                            <span className="issue-category-title">
                              Issue Sub-Category: &nbsp;
                            </span>
                            {get(issue, "subCategory", "NA")}
                          </span>
                          <span className="clowdy" />
                        </p>
                      ) : null}
                      {get(issue, "proposalNoParivesh") ? (
                        <p className="issue-sub-category to-n-fro">
                          <span className="slide-issue">
                            <span className="issue-category-title">
                              Proposal No. (PARIVESH): &nbsp;
                            </span>
                            <span
                              className="proposal-link"
                              onClick={this.showPraiveshModal}
                            >
                              {get(issue, "proposalNoParivesh", "NA")}
                            </span>
                          </span>
                          <span className="clowdy" />
                        </p>
                      ) : null}
                    </div>
                  </div>
                  {(meetingStatus === "DRAFT" &&
                    get(issue, "latestIssueComments") && (
                      <div className="issue-list-comment">
                        <div className="comment-heading">
                          <h3>Latest Comment</h3>
                        </div>
                        {/* <DisplayContent
                          classes={"issue-list-desc"}
                          content={get(issue, "latestIssueComments")}
                        /> */}
                        <DisplayHtmlContent
                          classes={`issue-list-desc ${
                            get(issue, "latestIssueComments.comment").match(
                              /[\u0900-\u097F]/
                            )
                              ? "hindi-text-no-weight"
                              : ""
                          }`}
                          showCreatedInfo={false}
                          content={get(issue, "latestIssueComments")}
                        />
                      </div>
                    )) ||
                    null}
                </div>
                {/* check if page is agenda-detail start*/}
                {console.log(
                  "fromAgendaDetailPage",
                  fromAgendaDetailPage,
                  "isPragatiReview",
                  isPragatiReview,
                  "isPragatiPipeline",
                  isPragatiPipeline
                )}
                {fromAgendaDetailPage ? (
                  // get(issue, "status") === "Pending with SM" ||
                  // get(issue, "status") === "Pending with PMG" ? (
                  //   <AgendaIssuePragatiReview
                  //     isPragati={get(issue, "issuePragatiReview")}
                  //     isAgendaDetail={true}
                  //     className="issue_pragati_flag agenda_detail pendingwithsmpmg"
                  //   />
                  // ) : (
                  //   <div className="unique-class">
                  //     <AgendaIssueDecision
                  //       agendaData={agendaData}
                  //       handleUpdateStatus={handleUpdateStatus}
                  //       issue={issue}
                  //       permission={permission}
                  //       project={project}
                  //       isPragati={get(issue, "issuePragatiReview")}
                  //       pragatiClassName="issue_pragati_flag agenda_detail"
                  //     />
                  //     {/* <AgendaIssuePragatiReview
                  //     isPragati={get(issue, "issuePragatiReview")}
                  //     isAgendaDetail={true}
                  //     className="issue_pragati_flag agenda_detail"
                  //   /> */}
                  //   </div>
                  // )
                  <>
                    <div className="unique-class">
                      <AgendaIssueDecision
                        agendaData={agendaData}
                        handleUpdateStatus={handleUpdateStatus}
                        issue={issue}
                        permission={permission}
                        project={project}
                        isPragati={isPragatiReview}
                        isPragatiPipeline={isPragatiPipeline}
                        pragatiClassName="issue_pragati_flag agenda_detail"
                      />
                    </div>
                  </>
                ) : (
                  // <AgendaIssuePragatiReview
                  //   isPragati={get(issue, "issuePragatiReview")}
                  //   isAgendaDetail={true}
                  //   className="issue_pragati_flag agenda_detail draft"
                  // />
                  <>
                    {isPragatiReview ? (
                      <AgendaIssuePragatiReview
                        isPragati={isPragatiReview}
                        isAgendaDetail={true}
                        className="issue_pragati_flag agenda_detail draft"
                      />
                    ) : isPragatiPipeline ? (
                      <AgendaIssuePragatiPipeline
                        isPragatiPipeline={isPragatiPipeline}
                        isAgendaDetail={true}
                        className="issue_pipeline_flag agenda_detail draft"
                      />
                    ) : null}
                  </>
                )}
                {/* check if page is agenda-detail end*/}
              </div>
            </div>
          </div>
        </div>
        <DisplayByPermission display={isPariveshModalVisible}>
          <PariveshData
            show={isPariveshModalVisible}
            closeModal={this.closePariveshModal}
            issueSubCategoryId={this.state.selectedIssueSubCategoryId}
            proposalNoParivesh={this.state.selectedProposalNoParivesh}
          />
        </DisplayByPermission>
      </React.Fragment>
    );
  }
}

export default IssueSingle;
